<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <!-- <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button> -->
        </b-form>
      </div>

      <div
        slot="id"
        slot-scope="props"
        @click="clickDetailPage(props.row)">
        {{ props.row.id }}
      </div>

      <div
        slot="tahunajaran"
        slot-scope="props"
        @click="clickDetailPage(props.row)">
        {{ props.row.tahunajaran }}
      </div>

      <div
        slot="total_siswa"
        slot-scope="props"
        @click="clickDetailPage(props.row)">
        {{ props.row.total_siswa }}
      </div>

      <!-- <div
        slot="action"
        slot-scope="props">
        <i
          class="fa fa-lg fa-pencil cursor-pointer"
          @click="clickDetail(props.row)"/>
      </div> -->
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-popover
      ref="searchModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="searchData"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="modalTahunAjaran"
      class="mod-form modal-tahun-ajaran"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="title-bold ql-align-center">{{ data_master.id ? 'Rubah' : 'Tambah' }} Tahun Ajaran</div>

      <b-form-group :class="{'error-input' : $v.data_master.tahunajaran.$error}">
        <label> Tahun Ajaran </label>
        <j-input
          v-model="$v.data_master.tahunajaran.$model"
          placeholder="Tahun Ajaran"/>
      </b-form-group>

      <b-row>
        <b-col md="4">
          <b-button
            v-if="data_master.id"
            class="btn red"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="8">
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeData">
              Cancel
            </b-button>
            <b-button
              class="btn blue m__l--5"
              @click="saveData">
              {{ data_master.id ? 'Update' : 'Save' }}
            </b-button>
          </div>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Tahun Ajaran',
      },
      data_master: {
        tahunajaran: '',
      },
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'title',
      options_search: [
        {
          text: 'TITLE',
          value: 'title',
        },
        {
          text: 'CATEGORY',
          value: 'category_name',
        },
      ],
      load_first: false,
      data_table: [],
      columns: ['id', 'tahunajaran', 'total_siswa'],
      options: {
        headings: {
          id: 'ID',
          tahunajaran: 'TAHUN AJARAN',
          total_siswa: 'TOTAL SISWA',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              query: '',
              query_type: 'tahunajaran',
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.listTahunAjaran(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['createTahunAjaran', 'updateTahunAjaran', 'deleteTahunAjaran']),

    loading(val) {
      const a = val;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    createData() {
      this.$refs.modalTahunAjaran.show();
    },

    closeData() {
      this.$refs.modalTahunAjaran.hide();
      this.data_master = {
        tahunajaran: '',
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        const action = this.data_master.id ? 'updateTahunAjaran' : 'createTahunAjaran';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeData();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteTahunAjaran(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeData();
              }, 1500);
            }
          });
        }
      });
    },

    clickDetail(row) {
      this.$refs.modalTahunAjaran.show();
      this.data_master = {
        id: row.id,
        tahunajaran: row.tahunajaran,
      };
    },

    clickDetailPage(row) {
      this.$router.push(`/admin-kelas/kelas/${row.id}`);
    },
  },
  validations() {
    return {
      data_master: {
        tahunajaran: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-kelas/jTahunAjaran.vue